import React from "react";

interface UnaiProps {
  customUrl?: string;
}

const Unai: React.FC<UnaiProps> = ({ customUrl }) => {
  let url = "https://unai.synk.ws";

  if (customUrl) {
    url = customUrl;
  }

  if (process.env.REACT_APP_DEV_MODE === "true") {
    console.log("🤖 Unai - Props reçues:");
    console.log("  - customUrl:", customUrl);
    console.log("  - URL finale:", url);
  }

  return (
    <div className="w-full h-full">
      <iframe
        src={url}
        title="Unai"
        className="w-full h-full border-none"
        sandbox="allow-scripts allow-same-origin allow-popups allow-downloads allow-clipboard-write"
        allow="camera; microphone; fullscreen; clipboard-write"
      />
    </div>
  );
};

export default Unai;
